
import { Component, EventEmitter, inject, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { App } from '@vendasta/embeddings';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { AiKnowledgeI18nModule } from '../assets/i18n/ai-knowledge-i18n.module';
import { AiKnowledgeService } from '../services/ai-knowledge.service';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ai-knowledge-application-list',
  imports: [
    TranslateModule,
    AiKnowledgeI18nModule,
    MatIconModule,
    MatListModule,
    GalaxyAvatarModule,
    RouterModule
],
  templateUrl: './application-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./application-list.component.scss'],
})
export class ApplicationListComponent {
  @Input() hideRemove = false;
  @Input()
  get apps(): App[] {
    return this._apps;
  }
  set apps(apps: App[]) {
    this._apps = (apps || []).sort((a, b) => {
      return a?.name?.localeCompare(b?.name) || 0;
    });
  }
  _apps: App[] = [];

  @Output() removeClicked = new EventEmitter<App>();

  private readonly knowledgeService = inject(AiKnowledgeService);

  clickRemove(app: App): void {
    this.removeClicked.emit(app);
  }

  getAppDisplayName(app: App): string {
    return this.knowledgeService.getAppDisplayName(app);
  }
}
